export default __webpack_public_path__ + "static/media/Tasset of Heroic Soul.5f6f399c.jpg";